import React from "react";
import styled from "styled-components";

// components
import CoreTNPLogoType from "core/SiteHeader/components/TNPLogoType";

// data
import { TNP_LOGO_TYPE_WIDTH } from "core/SiteHeader/TabletDesktop/Layout/constants.js";

// styles
import { convertPxToRem } from "frontend/components/helpers";
import breakpoints from "core/breakpoints";
const TnpLogoTypeStyled = styled.div`
    display: none;

    @media (min-width: ${breakpoints.desktop.rem}) {
        display: block;
        flex: 0 0 ${convertPxToRem(TNP_LOGO_TYPE_WIDTH)};

        display: flex;
        align-items: center;
    }
`;

// component
export const TnpLogoType = () => {
    return (
        <TnpLogoTypeStyled>
            <CoreTNPLogoType />
        </TnpLogoTypeStyled>
    );
};

export default TnpLogoType;
